import store from "../configureStore";

export type LocalizationKey =
  | "nextButton"
  | "appointment"
  | "noAppointment"
  | "noAppointmentMessage1"
  | "appointmentMessage1part1"
  | "appointmentMessage1part2"
  | "appointmentMessage1part3"
  | "carrier"
  | "checkout"
  | "home"
  | "firstName"
  | "secondName"
  | "next"
  | "frontPageTitle"
  | "frontPageTitleLouisP"
  | "numberPageTitle"
  | "keyCardPageTitle"
  | "keyCardCheckBox"
  | "mainfieldsPageTitle"
  | "customFieldsPageTitle"
  | "employeePageTitle"
  | "employeePageTitleHost"
  | "messagePageTitle"
  | "checkinMessage"
  | "checkoutMessage"
  | "namePlaceholder"
  | "touchTheScreen"
  | "searchPlaceholder"
  | "searchHostPlaceholder"
  | "frontPageSubtext"
  | "hr"
  | "other"
  | "checkinNoInfo"
  | "language"
  | "numberPlaceholder"
  | "customOfficeFieldsPageTitle"
  | "namePlaceholderExample"
  | "companyPlaceholderExample"
  | "goodbyeMessage1"
  | "goodbyeMessage2"
  | "goodbyeMessage3"
  | "edFrontPageTitle"
  | "edInserValue"
  | "edCompanyPlaceholder"
  | "contactButton"
  | "goodbye1Edforhandler"
  | "goodbye2Edforhandler"
  | "goodbye3Edforhandler"
  | "behandling"
  | "fællesskab"
  | "mentorsamtale"
  | "praktikshjælp"
  | "hf"
  | "frivillig"
  | "ja"
  | "nej"
  | "visionSubfirma"
  | "visionIngenAftale"
  | "welcome"
  | "groupcheckin"
  | "groupPlaceholder"
  | "Erhvervmidtjylland"
  | "ErhvervmidtjyllandNoAppointment"
  | "Erhvervmidtjyllandmessage"
  | "ErhvervmidtjyllandPostmessage"
  | "sefGDPR"
  | "namePlaceholderED"
  | "levenrandoer"
  | "levenrandoerGoodbye"
  | "checkinreisswolf"
  | "checkudresswolf"
  | "EDevent"
  | "EDappointment"
  | "EDnoappointment"
  | "CompanyPlaceholder"
  | "EdEventMessage"
  | "checkoutlist"
  | "checkoutlistname"
  | "checkoutlistcompany"
  | "checkoutlistdate"
  | "checkoutlisttime"
  | "continue"
  | "back"
  | "confirmCheckin"
  | "confirmCheckout"
  | "reisswolftCheckinSecondtitle"
  | "reisswolftCheckinFollowtitle"
  | "reisswolftCheckinFollowemployee"
  | "reisswolftInputName"
  | "reisswolftInputCompany"
  | "kjaergaardThanksRegistered"
  | "kjaergaardThanksForVisit"
  | "kjaergaardNoAppointment"
  | "kjaergaardGoToReception"
  | "kjaergaardGoToHelp"
  | "kjaergaardFetchYou"
  | "kjaergaardCheckedOut"
  | "acceptTemsAndConditions"
  | "departmentsTitle"
  | "flenstedDepartmentsSubTitle"
  | "carpenter"
  | "guest"
  | "applicant"
  | "purposeEmpty"
  | "purposeCarpenter"
  | "purposeGuest"
  | "purposeApplicant"
  | "lastInOfficeTitle"
  | "redForVisitors"
  | "blueForVisitors"
  | "HaugenNoAppointment"
  | "haugenCarrier"
  | "HotWork"
  | "NotHotWork"
  | "CustomFlowcardPageTitle"
  | "WelcomeDinexTMLHouse"
  | "GuestRegistration"
  | "visitorPhoneNumberInputLabel"
  | "visitorNameInputLabel"
  | "visitorCompanyNameInputLabel"
  | "simpleCheckinCompleteMessage"
  | "externalServiceButton"
  | "carpenterSimple"
  | "EDPhoneNumberPageTitle"
  | "LauritzenAppointmentMessage1Part1"
  | "LauritzenAppointmentMessage1Part2";

export class LocalizationDictionary {
  private static danishDictionary: Dictionary<LocalizationKey, string> = {
    visitorPhoneNumberInputLabel: "Telefonnummer",
    visitorCompanyNameInputLabel: "Firmanavn",
    visitorNameInputLabel: "Navn",
    nextButton: "Næste",
    appointment: "Har aftale",
    appointmentMessage1part1: "Vent venligst og tag plads, ",
    appointmentMessage1part2:
      " er blevet informeret om din ankomst og er på vej. Tag key hanger efter anvisningen nedenfor.",
    appointmentMessage1part3:
      "er informeret og vil være hos dig om lidt. Venligst tag plads.",
    noAppointment: "Ingen aftale",
    noAppointmentMessage1: "Henvend dig i receptionen.",
    //'carrier': "Fragtmand",
    carrier: "Fragtmand",
    checkout: "Tjek ud",
    home: "Start",
    firstName: "Fornavn",
    secondName: "Efternavn",
    next: "Næste",
    frontPageTitle: "Velkommen til ",
    frontPageTitleLouisP: "Check ind her",
    numberPageTitle: "Indtast dit mobilnummer",
    keyCardPageTitle: "Indtast nøglekorts nummer",
    keyCardCheckBox: "Jeg har ikke et nøglekort",
    mainfieldsPageTitle: "Indtast dine oplysninger",
    customFieldsPageTitle: "Indtast dine oplysninger",
    employeePageTitle: "Vælg den ønskede medarbejder",
    employeePageTitleHost: "Vælg din vært",
    messagePageTitle: "Vent venligst og tag plads",
    checkinMessage:
      "Vent venligst og tag plads, en medarbejder er blevet informeret om din ankomst og er på vej",
    checkoutMessage: "Tak, din udtjekning er blevet registreret",
    namePlaceholder: "Indtast navn og efternavn",
    touchTheScreen: "Tryk på skærmen",
    searchPlaceholder: "Søg medarbejder",
    searchHostPlaceholder: "Søg efter vært",
    frontPageSubtext: "Registrér dig venligst her",
    hr: "HR / Job ansøgninger",
    other: "Andet",
    checkinNoInfo: "Aftalt møde",
    language: "DK",
    numberPlaceholder: "Eksempel +45 88 88 88 88",
    customOfficeFieldsPageTitle: "Indtast din virksomhed",
    namePlaceholderExample: "Eksempel: John Jensen",
    companyPlaceholderExample: "Eksempel: Jysk A/S",
    goodbyeMessage1: "Du er nu registreret, og din vært er blevet kontaktet",
    goodbyeMessage2: "Tag venligst plads i receptionen.",
    goodbyeMessage3: "Vent venligst her",
    edFrontPageTitle: "Venligst vælg:",
    edInserValue: "Indtast venligst:",
    edCompanyPlaceholder: "Dit firmanavn (valgfrit)",
    contactButton: "Godkend",
    goodbye1Edforhandler: "Din vært har fået besked om dit ankomst.",
    goodbye2Edforhandler:
      "Vent venligst, en medarbejder vil åbne døren for dig.",
    goodbye3Edforhandler:
      "Vent venligst, en medarbejder vil åbne døren for dig.",
    behandling: "BEHANDLINGSRUM",
    fællesskab: "FÆLLESSKAB & AKTIVITETER",
    mentorsamtale: "MENTORSAMTALE",
    praktikshjælp: "PRAKTISK HJÆLP",
    hf: "JEG GÅR PÅ HF",
    frivillig: "FUNDABOLIG",
    ja: "JA",
    nej: "NEJ",
    visionSubfirma: "Tryk venligst på den virksomhed du skal besøge",
    visionIngenAftale: "Har du ingen aftale - klik her",
    welcome: "Velkommen",
    groupcheckin: "Gruppe aftale",
    groupPlaceholder: "Indtast antal deltagere",
    Erhvervmidtjylland: "Meld din ankomst – og fortsæt gennem døren til højre",
    ErhvervmidtjyllandNoAppointment: "Ønsker hjælp",
    Erhvervmidtjyllandmessage: " er informeret om din ankomst",
    ErhvervmidtjyllandPostmessage:
      "Kom indenfor - du finder vores sofa bag døren for enden af gangen",
    sefGDPR:
      "Dine kontaktoplysninger (navn og telefonnummer) indsamles og opbevares i forbindelse med dit besøg, så SEF har et overblik over hvem der er i bygningen i tilfælde af en beredskabssituation. Dine data slettes når du tjekker ud efter dit besøg. Du kan læse mere om SEF’s privatlivspolitik på dette link:",
    namePlaceholderED: "Indtast dit navn",
    levenrandoer: "Leverandør",
    levenrandoerGoodbye: "Velkommen, tag venligst plads ved leverandør bordet.",
    checkinreisswolf: "CHECK IND",
    checkudresswolf: "CHECK UD",
    EDevent: "Jeg skal deltage i et event",
    EDappointment: "Jeg har en aftale",
    EDnoappointment: "Jeg har ikke en aftale",
    CompanyPlaceholder: "Dit firmanavn",
    EdEventMessage:
      "Tak for registrering.**Du kan hænge dit overtøj i garderoben :-)",
    checkoutlist: "VÆLG DIT NAVN PÅ LISTEN",
    checkoutlistname: "NAVN",
    checkoutlistcompany: "VIRKSOMHED",
    checkoutlistdate: "DATO",
    checkoutlisttime: "TIDSPUNKT",
    continue: "FORTSÆT",
    back: "TILBAGE",
    confirmCheckin: "BEKRÆFT CHECK IND FOR",
    confirmCheckout: "BEKRÆFT CHECK UD FOR",
    reisswolftCheckinSecondtitle: "INDTAST OPLYSNINGER",
    reisswolftCheckinFollowtitle: "VÆLG MEDARBEJDER AT FØLGES MED",
    reisswolftCheckinFollowemployee: " kommer og henter dig",
    reisswolftInputName: "FORNAVN & EFTERNAVN",
    reisswolftInputCompany: "VIRKSOMHED",
    kjaergaardThanksRegistered: "Tak, du er nu registreret",
    kjaergaardThanksForVisit: "Tak for besøget",
    kjaergaardNoAppointment: "Har du ingen aftale?",
    kjaergaardGoToReception:
      "Tag venligst plads i vores venteområde på 2. sal - til venstre for trappen.\nEfter endt besøg, venligst check ud her igen",
    kjaergaardGoToHelp:
      "Henvend dig venligst i receptionen,\npå 2. sal til venstre, for hjælp.",
    kjaergaardFetchYou: "har fået besked om din ankomst \n \n",
    kjaergaardCheckedOut:
      "Du er nu tjekket ud\nVi ønsker dig en rigtig god dag",
    acceptTemsAndConditions: "Accepterer du betingelserne?",
    departmentsTitle: "Vælg afdeling",
    flenstedDepartmentsSubTitle:
      "Vælg den afdeling hvor din kontakt er tilknyttet",
    carpenter: "Er du håndværker?",
    guest: "Er du gæst?",
    applicant: "Er du ansøger?",
    purposeEmpty: "",
    purposeCarpenter: "Håndværker",
    purposeGuest: "Gæst",
    purposeApplicant: "Ansøger",
    lastInOfficeTitle:
      "Marker nedenfor hvis du er den sidste person der forlader virksomheden",
    redForVisitors: "Rød for besøgende",
    blueForVisitors: "Blå for eksterne medarbejdere",
    HaugenNoAppointment: "Ring venligst til kundeservice på\n+45 35 34 30 00",
    haugenCarrier:
      "Gå venligst til indgangen ved lastbil chaufførene\n(døren til venstre for hovedindgangen)",
    HotWork: "Jeg skal arbejde med varmt arbejde",
    NotHotWork: "Jeg skal ikke arbejde med varmt arbejde",
    CustomFlowcardPageTitle:
      "Vælg venligst, hvis du er i tvivl kontakt venligst receptionen.",
    WelcomeDinexTMLHouse:
      "Velkommen til Dinex A/S &\nTML Safety Engineering A/S",
    GuestRegistration: "Gæste registrering",
    simpleCheckinCompleteMessage: "Du er nu tjekket ind - hav en god dag!",
    externalServiceButton: "Ekstern Service",
    carpenterSimple: "Håndværker",
    EDPhoneNumberPageTitle:
      "Ønsker du at modtage praktisk information omkring lademuligheder og WiFi? (Valgfrit)",
    LauritzenAppointmentMessage1Part1: "Tag venligst plads.",
    LauritzenAppointmentMessage1Part2:
      " er informeret og vil være hos dig snart.",
  };

  private static englishDictionary: Dictionary<LocalizationKey, string> = {
    visitorPhoneNumberInputLabel: "Phone number",
    visitorCompanyNameInputLabel: "Company name",
    visitorNameInputLabel: "Name",
    nextButton: "Next",
    appointment: "I have an appointment",
    appointmentMessage1part1: "Please wait and have a seat, ",
    appointmentMessage1part2:
      " has been informed of your arrival and is on the way. Grab a key hanger as instructed beneath.",
    appointmentMessage1part3:
      "is informed and will be with you shortly. Please have a seat.",
    noAppointment: "No appointment",
    noAppointmentMessage1: "Please contact the reception.",
    carrier: "I'm a courier",
    checkout: "Checkout",
    home: "Home",
    firstName: "Name",
    secondName: "Surname",
    next: "Next",
    frontPageTitle: "Welcome to ",
    frontPageTitleLouisP: "Check in here ",
    numberPageTitle: "Please enter your phone number",
    keyCardPageTitle: "Enter key card number",
    keyCardCheckBox: "I do not have a key card",
    mainfieldsPageTitle: "Please enter your information",
    customFieldsPageTitle: "Please enter your information",
    employeePageTitle: "Choose an employee",
    employeePageTitleHost: "Choose your host",
    messagePageTitle: "Please wait and take a seat",
    checkinMessage:
      "Please wait and have a seat, someone has been informed of your arrival and is on the way",
    checkoutMessage: "Thanks, you are checked out",
    namePlaceholder: "First name and surname",
    touchTheScreen: "Touch the screen",
    searchPlaceholder: "Search employee",
    searchHostPlaceholder: "Search hosts",
    frontPageSubtext: "Please register your arrival here",
    hr: "HR / Job applications",
    other: "Other",
    checkinNoInfo: "I have an appointment",
    language: "EN",
    numberPlaceholder: "Example +45 88 88 88 88",
    customOfficeFieldsPageTitle: "Please enter your company",
    namePlaceholderExample: "Example: John Jensen",
    companyPlaceholderExample: "Example: Jysk A/S",
    goodbyeMessage1: "You are now registered and your host has been contacted.",
    goodbyeMessage2: "Please have a seat in the Reception.",
    goodbyeMessage3: "Please wait here.",
    edFrontPageTitle: "Please select:",
    edInserValue: "Please enter:",
    edCompanyPlaceholder: "Company name (optional)",
    contactButton: "OK",
    goodbye1Edforhandler:
      "Your host has received a notification of your arrival.",
    goodbye2Edforhandler:
      "Please wait, an employee will open the door for you.",
    goodbye3Edforhandler:
      "Please wait, an employee will open the door for you.",
    behandling: "",
    fællesskab: "",
    mentorsamtale: "",
    praktikshjælp: "",
    hf: "",
    frivillig: "",
    ja: "YES",
    nej: "NO",
    visionSubfirma: "Please click on the company you are visiting",
    visionIngenAftale: "If you have no appointment - click here",
    welcome: "Welcome",
    groupcheckin: "Group appointment",
    groupPlaceholder: "Number of participants",
    Erhvervmidtjylland:
      "Please check-in and continue through the door to your right",
    ErhvervmidtjyllandNoAppointment: "Need help",
    Erhvervmidtjyllandmessage: " has been informed of your arrival",
    ErhvervmidtjyllandPostmessage:
      "Please come in - you'll find our couch behind the door at the end of the hall",
    sefGDPR:
      "Your contact information (name and telephone number) is collected and stored in connection with your visit, so that SEF has an overview of who is in the building in the event of an emergency situation. Your data is deleted when you check out after your visit. You can read more about SEF's privacy policy at this link:",
    namePlaceholderED: "Insert your name",
    levenrandoer: "supplier",
    levenrandoerGoodbye: "Welcome, please take a seat at the supplier table.",
    checkinreisswolf: "CHECK IN",
    checkudresswolf: "CHECK OUT",
    EDevent: "I'm attending an event",
    EDappointment: "I have an appointment",
    EDnoappointment: "I do not have an appointment",
    CompanyPlaceholder: "Your company name",
    EdEventMessage:
      "Thank you for registration. **You can hang your outerwear in the wardrobe :-)",
    checkoutlist: "CHOOSE YOUR NAME ON THE LIST",
    checkoutlistname: "NAME",
    checkoutlistcompany: "COMPANY",
    checkoutlistdate: "DATE",
    checkoutlisttime: "TIME",
    continue: "CONTINUE",
    back: "BACK",
    confirmCheckin: "CONFIRM CHECK IN FOR",
    confirmCheckout: "CONFIRM CHECK OUT FOR",
    reisswolftCheckinSecondtitle: "ENTER DETAILS",
    reisswolftCheckinFollowtitle: "CHOOSE EMPLOYEE TO FOLLOW",
    reisswolftCheckinFollowemployee: " will come and get you",
    reisswolftInputName: "FIRSTNAME & LASTNAME",
    reisswolftInputCompany: "COMPANY",
    kjaergaardThanksRegistered: "Thanks, you are now registered",
    kjaergaardThanksForVisit: "Thanks for the visit",
    kjaergaardNoAppointment: "Do you not have an appointment?",
    kjaergaardGoToReception:
      "Please contact the receptionen, on the 2nd floor to the left, where",
    kjaergaardGoToHelp:
      "Please contact the receptionen,\non the 2nd floor to the left, for help.",
    kjaergaardFetchYou:
      "will get you.\nBefore leaving, please check out here again.",
    kjaergaardCheckedOut:
      "You are now checked out\nWe hope you have a great day",
    acceptTemsAndConditions: "Do you accept the terms?",
    departmentsTitle: "Choose department",
    flenstedDepartmentsSubTitle:
      "Choose the department where your contact is registered",
    carpenter: "Are you a contractor?",
    guest: "Are you a guest?",
    applicant: "Are you an applicant?",
    purposeEmpty: "",
    purposeCarpenter: "Contractor",
    purposeGuest: "Guest",
    purposeApplicant: "Applicant",
    lastInOfficeTitle:
      "Mark below if you are the last person leaving the company",
    redForVisitors: "Red for visitors",
    blueForVisitors: "Blue for external workers",
    HaugenNoAppointment: "Please call customer service\n+45 35 34 30 00",
    haugenCarrier:
      "Please go to the truck driver’s entrance\n(door to the left of the main entrance)",
    HotWork: "I need to work with hot work",
    NotHotWork: "I do not need to work with hot work",
    CustomFlowcardPageTitle:
      "Please choose, if you are in doubt please contact the reception.",
    WelcomeDinexTMLHouse: "Welcome to Dinex A/S &\nTML Safety Engineering A/S",
    GuestRegistration: "Guest Registration",
    simpleCheckinCompleteMessage: "You are now checked in - have a great day!",
    externalServiceButton: "External Service",
    carpenterSimple: "Carpenter",
    EDPhoneNumberPageTitle:
      "Do you want to receive practical information about charging options and WiFi? (Optional)",
    LauritzenAppointmentMessage1Part1: "Please be seated. ",
    LauritzenAppointmentMessage1Part2:
      " is informed and will be with you shortly.",
  };

  private static germanDictionary: Dictionary<LocalizationKey, string> = {
    visitorPhoneNumberInputLabel: "Telefonnummer",
    visitorCompanyNameInputLabel: "Firmenname",
    visitorNameInputLabel: "Name",
    nextButton: "Weiter",
    appointment: "Ich habe einen Termin",
    appointmentMessage1part1:
      "Bitte warten Sie einen Moment und nehmen Sie Platz, ",
    appointmentMessage1part2:
      " Sie wurden über Ihre Ankunft informiert und sind auf dem Weg. Bitte nehmen Sie den Schlüsselanhänger gemäß den Anweisungen unten.",
    appointmentMessage1part3:
      "ist informiert und wird in Kürze bei Ihnen sein. Bitte nehmen Sie Platz.",
    noAppointment: "Kein Termin",
    noAppointmentMessage1: "Bitte wenden Sie sich an die Rezeption.",
    carrier: "Ich bin ein Kurier",
    checkout: "Auschecken",
    home: "Startseite",
    firstName: "Vorname",
    secondName: "Nachname",
    next: "Weiter",
    frontPageTitle: "Willkommen bei ",
    frontPageTitleLouisP: "Hier einchecken",
    numberPageTitle: "Bitte geben Sie Ihre Telefonnummer ein",
    keyCardPageTitle: "Geben Sie die Kartennummer ein",
    keyCardCheckBox: "Ich habe keine Schlüsselkarte",
    mainfieldsPageTitle: "Bitte geben Sie Ihre Informationen ein",
    customFieldsPageTitle: "Bitte geben Sie Ihre Informationen ein",
    employeePageTitle: "Wählen Sie einen Mitarbeiter aus",
    employeePageTitleHost: "Wählen Sie Ihren Gastgeber",
    messagePageTitle: "Bitte warten Sie und nehmen Sie Platz",
    checkinMessage:
      "Bitte warten Sie und nehmen Sie Platz. Jemand wurde über Ihre Ankunft informiert und ist auf dem Weg.",
    checkoutMessage: "Vielen Dank, Sie haben ausgecheckt",
    namePlaceholder: "Vorname und Nachname",
    touchTheScreen: "Bildschirm berühren",
    searchPlaceholder: "Mitarbeiter suchen",
    searchHostPlaceholder: "Gastgeber suchen",
    frontPageSubtext: "Bitte melden Sie sich hier an",
    hr: "Personalabteilung / Bewerbungen",
    other: "Sonstiges",
    checkinNoInfo: "Ich habe einen Termin",
    language: "DE",
    numberPlaceholder: "Beispiel: +45 88 88 88 88",
    customOfficeFieldsPageTitle: "Bitte geben Sie Ihr Unternehmen ein",
    namePlaceholderExample: "Beispiel: John Jensen",
    companyPlaceholderExample: "Beispiel: Jysk A/S",
    goodbyeMessage1:
      "Sie sind jetzt registriert, und Ihr Gastgeber wurde benachrichtigt.",
    goodbyeMessage2: "Bitte nehmen Sie im Empfangsbereich Platz.",
    goodbyeMessage3: "Bitte warten Sie hier.",
    edFrontPageTitle: "Bitte auswählen:",
    edInserValue: "Bitte eingeben:",
    edCompanyPlaceholder: "Firmenname (optional)",
    contactButton: "OK",
    goodbye1Edforhandler: "Ihr Gastgeber wurde über Ihre Ankunft informiert.",
    goodbye2Edforhandler:
      "Bitte warten Sie, ein Mitarbeiter wird Ihnen die Tür öffnen.",
    goodbye3Edforhandler:
      "Bitte warten Sie, ein Mitarbeiter wird Ihnen die Tür öffnen.",
    behandling: "",
    fællesskab: "",
    mentorsamtale: "",
    praktikshjælp: "",
    hf: "",
    frivillig: "",
    ja: "JA",
    nej: "NEIN",
    visionSubfirma: "Bitte klicken Sie auf das Unternehmen, das Sie besuchen",
    visionIngenAftale: "Wenn Sie keinen Termin haben - hier klicken",
    welcome: "Willkommen",
    groupcheckin: "Gruppen-Termin",
    groupPlaceholder: "Anzahl der Teilnehmer",
    Erhvervmidtjylland:
      "Haben Sie einen Termin mit einem Mitarbeiter? Oder benötigen Sie Hilfe? Hier auswählen.",
    ErhvervmidtjyllandNoAppointment: "Hilfe benötigt",
    Erhvervmidtjyllandmessage: "wurde über Ihre Ankunft informiert",
    ErhvervmidtjyllandPostmessage: "",
    sefGDPR:
      "Ihre Kontaktdaten (Name und Telefonnummer) werden erfasst und gespeichert, um SEF im Notfall einen Überblick darüber zu verschaffen, wer sich im Gebäude befindet. Ihre Daten werden gelöscht, wenn Sie nach Ihrem Besuch auschecken. Weitere Informationen zur Datenschutzrichtlinie von SEF finden Sie unter folgendem Link:",
    namePlaceholderED: "Ihren Namen eingeben",
    levenrandoer: "Lieferant",
    levenrandoerGoodbye:
      "Willkommen, bitte nehmen Sie am Lieferantentisch Platz.",
    checkinreisswolf: "EINCHECKEN",
    checkudresswolf: "AUSCHECKEN",
    EDevent: "Ich nehme an einer Veranstaltung teil",
    EDappointment: "Ich habe einen Termin",
    EDnoappointment: "Ich habe keinen Termin",
    CompanyPlaceholder: "Ihr Firmenname",
    EdEventMessage:
      "Vielen Dank für die Anmeldung. **Sie können Ihre Oberbekleidung in der Garderobe aufhängen :-)",
    checkoutlist: "IHREN NAMEN IN DER LISTE AUSWÄHLEN",
    checkoutlistname: "NAME",
    checkoutlistcompany: "UNTERNEHMEN",
    checkoutlistdate: "DATUM",
    checkoutlisttime: "UHRZEIT",
    continue: "WEITER",
    back: "ZURÜCK",
    confirmCheckin: "BESTÄTIGEN SIE EINCHECKEN FÜR",
    confirmCheckout: "BESTÄTIGEN SIE AUSCHECKEN FÜR",
    reisswolftCheckinSecondtitle: "DETAILS EINGEBEN",
    reisswolftCheckinFollowtitle: "MITARBEITER ZUM FOLGEN AUSWÄHLEN",
    reisswolftCheckinFollowemployee: "wird zu Ihnen kommen",
    reisswolftInputName: "VORNAME & NACHNAME",
    reisswolftInputCompany: "UNTERNEHMEN",
    kjaergaardThanksRegistered: "Vielen Dank, Sie sind jetzt registriert",
    kjaergaardThanksForVisit: "Vielen Dank für den Besuch",
    kjaergaardNoAppointment: "Haben Sie keinen Termin?",
    kjaergaardGoToReception:
      "Bitte wenden Sie sich an die Rezeption im 2. Stock links, wo",
    kjaergaardGoToHelp:
      "Bitte wenden Sie sich an die Rezeption,\nim 2. Stock links, um Hilfe zu erhalten.",
    kjaergaardFetchYou:
      "wird Sie abholen.\nBevor Sie gehen, melden Sie sich bitte auch hier wieder ab.",
    kjaergaardCheckedOut:
      "Sie sind jetzt ausgecheckt\nWir hoffen, Sie haben einen schönen Tag",
    acceptTemsAndConditions: "Akzeptieren Sie die Bedingungen?",
    departmentsTitle: "Abteilung auswählen",
    flenstedDepartmentsSubTitle:
      "Wählen Sie die Abteilung, in der Ihr Kontakt registriert ist",
    carpenter: "Bist du Handwerker?",
    guest: "Bist du Gast?",
    applicant: "Bist du Bewerber?",
    purposeEmpty: "",
    purposeCarpenter: "Handwerker",
    purposeGuest: "Gast",
    purposeApplicant: "Bewerber",
    lastInOfficeTitle:
      "Markieren Sie unten, wenn Sie die letzte Person sind, die das Unternehmen verlässt",
    redForVisitors: "Rot für Besucher",
    blueForVisitors: "Blau für externe Mitarbeiter",
    HaugenNoAppointment:
      "Rufen Sie bitte den Kundenservice unter an\n+45 35 34 30 00",
    haugenCarrier:
      "Gehen Sie bitte zum Eingang bei den LKW-Fahrern\n(die Tür links vom Haupteingang)",
    HotWork: "Ich muss Heißarbeiten durchführen",
    NotHotWork: "Ich muss keine Heißarbeiten durchführen",
    CustomFlowcardPageTitle:
      "Bitte wählen Sie, bei Zweifeln wenden Sie sich bitte an die Rezeption.",
    WelcomeDinexTMLHouse:
      "Willkommen bei Dinex A/S &\nTML Safety Engineering A/S",
    GuestRegistration: "Gästeanmeldung",
    simpleCheckinCompleteMessage:
      "Du bist jetzt eingecheckt - hab einen schönen Tag!",
    externalServiceButton: "Externer Dienst",
    carpenterSimple: "Handwerker",
    EDPhoneNumberPageTitle:
      "Möchten Sie praktische Informationen zu Ladeoptionen und WLAN erhalten? (Optional)",
    LauritzenAppointmentMessage1Part1: "Bitte nehmen Sie Platz. ",
    LauritzenAppointmentMessage1Part2:
      " ist informiert und wird bald zu Ihnen kommen.",
  };

  private static polishDictionary: Dictionary<LocalizationKey, string> = {
    visitorPhoneNumberInputLabel: "Numer telefonu",
    visitorCompanyNameInputLabel: "Nazwa firmy",
    visitorNameInputLabel: "Imię i nazwisko",
    nextButton: "Dalej",
    appointment: "Mam umówione spotkanie",
    appointmentMessage1part1: "Proszę zaczekać i zająć miejsce, ",
    appointmentMessage1part2:
      " Zostałeś poinformowany o twoim przybyciu i jesteśmy w drodze. Proszę odebrać uchwyt na klucze zgodnie z poniższą instrukcją.",
    appointmentMessage1part3:
      "jest poinformowany i wkrótce do Ciebie przyjdzie. Proszę usiąść.",
    noAppointment: "Brak umówionego spotkania",
    noAppointmentMessage1: "Proszę udać się do recepcji.",
    carrier: "Jestem kurierem",
    checkout: "Zakupy",
    home: "Strona główna",
    firstName: "Imię",
    secondName: "Nazwisko",
    next: "Dalej",
    frontPageTitle: "Witaj w ",
    frontPageTitleLouisP: "Zamelduj się tutaj",
    numberPageTitle: "Proszę podać numer telefonu",
    keyCardPageTitle: "Wprowadź numer karty",
    keyCardCheckBox: "Nie mam karty dostępu",
    mainfieldsPageTitle: "Proszę podać swoje informacje",
    customFieldsPageTitle: "Proszę podać swoje informacje",
    employeePageTitle: "Wybierz pracownika",
    employeePageTitleHost: "Wybierz swojego gospodarza",
    messagePageTitle: "Proszę czekać i zająć miejsce",
    checkinMessage:
      "Proszę czekać i zająć miejsce, ktoś został poinformowany o Twoim przyjeździe i jest w drodze",
    checkoutMessage: "Dziękujemy, zostałeś wyrejestrowany",
    namePlaceholder: "Imię i nazwisko",
    touchTheScreen: "Dotknij ekranu",
    searchPlaceholder: "Szukaj pracownika",
    searchHostPlaceholder: "Szukaj gospodarzy",
    frontPageSubtext: "Proszę zarejestrować swoje przybycie tutaj",
    hr: "HR / Aplikacje o pracę",
    other: "Inne",
    checkinNoInfo: "Mam umówione spotkanie",
    language: "PL",
    numberPlaceholder: "Przykład: +45 88 88 88 88",
    customOfficeFieldsPageTitle: "Proszę podać nazwę firmy",
    namePlaceholderExample: "Przykład: Jan Kowalski",
    companyPlaceholderExample: "Przykład: ABC Sp. z o.o.",
    goodbyeMessage1:
      "Jesteś teraz zarejestrowany, a Twój gospodarz został poinformowany.",
    goodbyeMessage2: "Proszę zająć miejsce w recepcji.",
    goodbyeMessage3: "Proszę czekać tutaj.",
    edFrontPageTitle: "Proszę wybrać:",
    edInserValue: "Proszę wprowadzić:",
    edCompanyPlaceholder: "Nazwa firmy (opcjonalnie)",
    contactButton: "OK",
    goodbye1Edforhandler:
      "Twój gospodarz został powiadomiony o Twoim przyjeździe.",
    goodbye2Edforhandler: "Proszę czekać, pracownik otworzy Ci drzwi.",
    goodbye3Edforhandler: "Proszę czekać, pracownik otworzy Ci drzwi.",
    behandling: "",
    fællesskab: "",
    mentorsamtale: "",
    praktikshjælp: "",
    hf: "",
    frivillig: "",
    ja: "TAK",
    nej: "NIE",
    visionSubfirma: "Proszę kliknąć na firmę, którą odwiedzasz",
    visionIngenAftale: "Jeśli nie masz umówionego spotkania - kliknij tutaj",
    welcome: "Witaj",
    groupcheckin: "Grupowe spotkanie",
    groupPlaceholder: "Liczba uczestników",
    Erhvervmidtjylland:
      "Czy masz umówione spotkanie z pracownikiem? Czy potrzebujesz pomocy? Wybierz tutaj.",
    ErhvervmidtjyllandNoAppointment: "Potrzebuję pomocy",
    Erhvervmidtjyllandmessage: "został poinformowany o Twoim przyjeździe",
    ErhvervmidtjyllandPostmessage: "",
    sefGDPR:
      "Twoje dane kontaktowe (imię i numer telefonu) są zbierane i przechowywane w związku z Twoją wizytą, aby SEF miało przegląd osób przebywających w budynku w przypadku sytuacji awaryjnej. Twoje dane są usuwane po wyrejestrowaniu się po wizycie. Więcej informacji na temat polityki prywatności SEF znajdziesz pod tym linkiem:",
    namePlaceholderED: "Wprowadź swoje imię",
    levenrandoer: "Dostawca",
    levenrandoerGoodbye: "Witaj, proszę zająć miejsce przy stole dostawcy.",
    checkinreisswolf: "ZAMELDUJ SIĘ",
    checkudresswolf: "WYMELDOWANIE",
    EDevent: "Uczestniczę w wydarzeniu",
    EDappointment: "Mam umówione spotkanie",
    EDnoappointment: "Nie mam umówionego spotkania",
    CompanyPlaceholder: "Nazwa Twojej firmy",
    EdEventMessage:
      "Dziękujemy za rejestrację. **Możesz zawiesić swoją odzież w szatni :-)",
    checkoutlist: "WYBIERZ SWOJĄ NAZWĘ Z LISTY",
    checkoutlistname: "NAZWA",
    checkoutlistcompany: "FIRMA",
    checkoutlistdate: "DATA",
    checkoutlisttime: "CZAS",
    continue: "KONTYNUUJ",
    back: "COFNIJ",
    confirmCheckin: "POTWIERDŹ ZAMELDOWANIE DLA",
    confirmCheckout: "POTWIERDŹ WYMELDOWANIE DLA",
    reisswolftCheckinSecondtitle: "WPROWADŹ SZCZEGÓŁY",
    reisswolftCheckinFollowtitle: "WYBIERZ PRACOWNIKA DO ŚLEDZENIA",
    reisswolftCheckinFollowemployee: "przyjdzie po Ciebie",
    reisswolftInputName: "IMIĘ I NAZWISKO",
    reisswolftInputCompany: "FIRMA",
    kjaergaardThanksRegistered: "Dziękujemy, teraz jesteś zarejestrowany",
    kjaergaardThanksForVisit: "Dziękujemy za wizytę",
    kjaergaardNoAppointment: "Nie masz umówionego spotkania?",
    kjaergaardGoToReception:
      "Proszę skontaktować się z recepcją na 2. piętrze po lewej stronie, gdzie",
    kjaergaardGoToHelp:
      "Proszę skontaktować się z recepcją,\nna 2. piętrze po lewej stronie, aby uzyskać pomoc.",
    kjaergaardFetchYou:
      "przyjdzie po Ciebie.\nPrzed opuszczeniem miejsca, proszę się tutaj wyrejestrować.",
    kjaergaardCheckedOut:
      "Jesteś teraz wyrejestrowany\nMamy nadzieję, że masz udany dzień",
    acceptTemsAndConditions: "Czy akceptujesz warunki?",
    departmentsTitle: "Wybierz dział",
    flenstedDepartmentsSubTitle:
      "Wybierz dział, w którym jest zarejestrowany Twój kontakt",
    carpenter: "Jesteś stolarzem?",
    guest: "Jesteś gościem?",
    applicant: "Jesteś kandydatem?",
    purposeEmpty: "",
    purposeCarpenter: "Rzemieślnik",
    purposeGuest: "Gość",
    purposeApplicant: "Wnioskodawca",
    lastInOfficeTitle:
      "Zaznacz poniżej, jeśli jesteś ostatnią osobą opuszczającą firmę",
    redForVisitors: "Czerwony dla odwiedzających",
    blueForVisitors: "Niebieski dla pracowników zewnętrznych",
    HaugenNoAppointment:
      "Proszę zadzwonić do obsługi klienta pod numer\n+45 35 34 30 00",
    haugenCarrier:
      "Proszę udać się do wejścia przy kierowcach ciężarówek\n(drzwi po lewej stronie od głównego wejścia)",
    HotWork: "Muszę wykonywać prace na gorąco",
    NotHotWork: "Nie muszę wykonywać prac na gorąco",
    CustomFlowcardPageTitle:
      "Proszę wybrać, w razie wątpliwości proszę skontaktować się z recepcją.",
    WelcomeDinexTMLHouse: "Witamy w Dinex A/S &\nTML Safety Engineering A/S",
    GuestRegistration: "Rejestracja gości",
    simpleCheckinCompleteMessage: "Jesteś już zameldowany - miłego dnia!",
    externalServiceButton: "Usługa zewnętrzna",
    carpenterSimple: "Stolar",
    EDPhoneNumberPageTitle:
      "Czy chcesz otrzymać praktyczne informacje o opcjach ładowania i WiFi? (Opcjonalnie)",
    LauritzenAppointmentMessage1Part1: "Proszę zająć miejsce. ",
    LauritzenAppointmentMessage1Part2:
      " został poinformowany i przyjedzie do Ciebie wkrótce.",
  };

  private static swedishDictionary: Dictionary<LocalizationKey, string> = {
    visitorPhoneNumberInputLabel: "Telefonnummer",
    visitorCompanyNameInputLabel: "Företagsnamn",
    visitorNameInputLabel: "Namn",
    nextButton: "Nästa",
    appointment: "Har möte",
    appointmentMessage1part1: "Vänligen vänta och ta plats, ",
    appointmentMessage1part2:
      " har blivit informerad om din ankomst och är på väg. Ta nyckelbricka enligt anvisningarna nedan.",
    appointmentMessage1part3:
      "är informerad och kommer att vara med dig om en stund. Vänligen ta plats.",
    noAppointment: "Inget möte",
    noAppointmentMessage1: "Vänligen kontakta receptionen.",
    carrier: "Bud",
    checkout: "Checka ut",
    home: "Hem",
    firstName: "Förnamn",
    secondName: "Efternamn",
    next: "Nästa",
    frontPageTitle: "Välkommen till ",
    frontPageTitleLouisP: "Checka in här",
    numberPageTitle: "Ange ditt mobilnummer",
    keyCardPageTitle: "Ange nyckelkortsnummer",
    keyCardCheckBox: "Jag har inget nyckelkort",
    mainfieldsPageTitle: "Ange dina uppgifter",
    customFieldsPageTitle: "Ange dina uppgifter",
    employeePageTitle: "Välj den önskade medarbetaren",
    employeePageTitleHost: "Välj din värd",
    messagePageTitle: "Vänligen vänta och ta plats",
    checkinMessage:
      "Vänligen vänta och ta plats, en medarbetare har blivit informerad om din ankomst och är på väg",
    checkoutMessage: "Tack, din utcheckning har registrerats",
    namePlaceholder: "Ange förnamn och efternamn",
    touchTheScreen: "Tryck på skärmen",
    searchPlaceholder: "Sök medarbetare",
    searchHostPlaceholder: "Sök efter värd",
    frontPageSubtext: "Registrera dig vänligen här",
    hr: "HR / Jobbansökningar",
    other: "Annat",
    checkinNoInfo: "Avtalat möte",
    language: "SE",
    numberPlaceholder: "Exempel +46 70 123 45 67",
    customOfficeFieldsPageTitle: "Ange ditt företag",
    namePlaceholderExample: "Exempel: Johan Johansson",
    companyPlaceholderExample: "Exempel: IKEA AB",
    goodbyeMessage1: "Du är nu registrerad och din värd har blivit kontaktad",
    goodbyeMessage2: "Vänligen ta plats i receptionen.",
    goodbyeMessage3: "Vänligen vänta här",
    edFrontPageTitle: "Vänligen välj:",
    edInserValue: "Ange vänligen:",
    edCompanyPlaceholder: "Ditt företagsnamn (valfritt)",
    contactButton: "Godkänn",
    goodbye1Edforhandler: "Din värd har fått besked om din ankomst.",
    goodbye2Edforhandler:
      "Vänligen vänta, en medarbetare kommer att öppna dörren åt dig.",
    goodbye3Edforhandler:
      "Vänligen vänta, en medarbetare kommer att öppna dörren åt dig.",
    behandling: "BEHANDLINGSRUM",
    fællesskab: "GEMENSKAP & AKTIVITETER",
    mentorsamtale: "MENTORSAMTAL",
    praktikshjælp: "PRAKTISK HJÄLP",
    hf: "JAG GÅR PÅ HF",
    frivillig: "Frivillig",
    ja: "JA",
    nej: "NEJ",
    visionSubfirma: "Tryck vänligen på det företag du ska besöka",
    visionIngenAftale: "Om du inte har något möte - klicka här",
    welcome: "Välkommen",
    groupcheckin: "Gruppmöte",
    groupPlaceholder: "Ange antal deltagare",
    Erhvervmidtjylland:
      "Har du ett möte med en medarbetare? Eller behöver du hjälp? Välj här.",
    ErhvervmidtjyllandNoAppointment: "Behöver hjälp",
    Erhvervmidtjyllandmessage: " har blivit informerad om din ankomst",
    ErhvervmidtjyllandPostmessage: "",
    sefGDPR:
      "Dina kontaktuppgifter (namn och telefonnummer) samlas in och lagras i samband med ditt besök, så att SEF har en överblick över vem som befinner sig i byggnaden vid en nödsituation. Dina uppgifter raderas när du checkar ut efter ditt besök. Du kan läsa mer om SEF:s integritetspolicy via denna länk:",
    namePlaceholderED: "Ange ditt namn",
    levenrandoer: "Leverantör",
    levenrandoerGoodbye: "Välkommen, ta vänligen plats vid leverantörsbordet.",
    checkinreisswolf: "CHECKA IN",
    checkudresswolf: "CHECKA UT",
    EDevent: "Jag ska delta i ett event",
    EDappointment: "Jag har ett möte",
    EDnoappointment: "Jag har inget möte",
    CompanyPlaceholder: "Ditt företagsnamn",
    EdEventMessage:
      "Tack för registreringen. **Du kan hänga ditt ytterplagg i garderoben :-)",
    checkoutlist: "VÄLJ DITT NAMN PÅ LISTAN",
    checkoutlistname: "NAMN",
    checkoutlistcompany: "FÖRETAG",
    checkoutlistdate: "DATUM",
    checkoutlisttime: "TID",
    continue: "FORTSÄTT",
    back: "TILLBAKA",
    confirmCheckin: "BEKRÄFTA INCHECKNING FÖR",
    confirmCheckout: "BEKRÄFTA UTCHECKNING FÖR",
    reisswolftCheckinSecondtitle: "ANGE UPPGIFTER",
    reisswolftCheckinFollowtitle: "VÄLJ MEDARBETARE ATT FÖLJA",
    reisswolftCheckinFollowemployee: " kommer och hämtar dig",
    reisswolftInputName: "FÖRNAMN & EFTERNAMN",
    reisswolftInputCompany: "FÖRETAG",
    kjaergaardThanksRegistered: "Tack, du är nu registrerad",
    kjaergaardThanksForVisit: "Tack för besöket",
    kjaergaardNoAppointment: "Har du inget möte?",
    kjaergaardGoToReception:
      "Vänligen kontakta receptionen, på 2:a våningen till vänster, där",
    kjaergaardGoToHelp:
      "Vänligen kontakta receptionen,\npå 2:a våningen till vänster, för hjälp.",
    kjaergaardFetchYou:
      "kommer att hämta dig.\nEfter besöket, vänligen checka ut här igen.",
    kjaergaardCheckedOut:
      "Du är nu utcheckad\nVi önskar dig en riktigt bra dag",
    acceptTemsAndConditions: "Accepterar du villkoren?",
    departmentsTitle: "Välj avdelning",
    flenstedDepartmentsSubTitle:
      "Välj den avdelning där din kontakt är registrerad",
    carpenter: "Är du hantverkare?",
    guest: "Är du gäst?",
    applicant: "Är du sökande?",
    purposeEmpty: "",
    purposeCarpenter: "Hantverkare",
    purposeGuest: "Gäst",
    purposeApplicant: "Sökande",
    lastInOfficeTitle:
      "Markera nedan om du är den sista personen som lämnar företaget",
    redForVisitors: "Röd för besökare",
    blueForVisitors: "Blå för externa medarbetare",
    HaugenNoAppointment: "Ring vänligen kundtjänst på\n+46 70 123 45 67",
    haugenCarrier:
      "Gå vänligen till ingången för lastbilschaufförerna\n(dörren till vänster om huvudentrén)",
    HotWork: "Jag ska arbeta med varmarbete",
    NotHotWork: "Jag ska inte arbeta med varmarbete",
    CustomFlowcardPageTitle:
      "Vänligen välj, om du är osäker kontakta receptionen.",
    WelcomeDinexTMLHouse:
      "Välkommen till Dinex A/S &\nTML Safety Engineering A/S",
    GuestRegistration: "Gästregistrering",
    simpleCheckinCompleteMessage: "Du är nu incheckad - ha en bra dag!",
    externalServiceButton: "Extern Service",
    carpenterSimple: "Hantverkare",
    EDPhoneNumberPageTitle:
      "Vill du ta emot praktisk information om laddningsalternativ och WiFi? (Valfritt)",
    LauritzenAppointmentMessage1Part1: "Vänligen ta plats. ",
    LauritzenAppointmentMessage1Part2:
      " är informerad och kommer att vara med dig om en stund.",
  };

  public static getStrings = () => {
    switch (store.getState().localization.language) {
      case "EN":
        return LocalizationDictionary.englishDictionary;
      case "DE":
        return LocalizationDictionary.germanDictionary;
      case "PL":
        return LocalizationDictionary.polishDictionary;
      case "SE":
        return LocalizationDictionary.swedishDictionary;
      default:
        return LocalizationDictionary.danishDictionary;
    }
  };
}
